import { TransformErrorMessageFn } from "@/components/form"

export const transformWrongCredentialsError: TransformErrorMessageFn =
  function handleTransformWrongCredentialsError(error) {
    const output = { message: error } as ReturnType<TransformErrorMessageFn>

    if (error.startsWith("Errors.invalidCredentials")) {
      const offset = error.lastIndexOf(".")
      const counter = Number(error.slice(offset + 1))

      output.message = error.slice(0, offset)
      output.messageProps = {
        counter,
        left: counter > 1 ? "tentativi" : "tentativo",
      }
    }
    return output
  }
